// config.js
const Url = {
    Url: "https://crmapi.auditusierp.com",  // replace with your real backend API URL or domain
    // Url: "http://localhost:5000",  // replace with your real backend API URL or domain

};

export default Url;
